import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  error: null,
  loading: false,
  scores: null,
};

const leaderboardScoresStart = (state) => (
  updateObject(state, {
    error: null,
    loading: true,
    scores: null,
  })
);

const leaderboardScoresSuccess = (state, action) => (
  updateObject(state, {
    error: null,
    loading: false,
    scores: action.scores,
  })
);

const leaderboardScoresFail = (state, action) => (
  updateObject(state, {
    error: action.error,
    loading: false,
  })
);

const reducer = (state = initialState, action = null) => {
  switch (action.type) {
    case actionTypes.LEADERBOARD_SCORES_START:
      return leaderboardScoresStart(state);
    case actionTypes.LEADERBOARD_SCORES_SUCCESS:
      return leaderboardScoresSuccess(state, action);
    case actionTypes.LEADERBOARD_SCORES_FAIL:
      return leaderboardScoresFail(state, action);
    default:
      return state;
  }
};

export default reducer;
